import { NextResponse } from 'next/server'
import { query, queryOne, uuid } from '@/lib/db'

export async function GET(req: Request) {
  const { searchParams } = new URL(req.url)
  const shopId = searchParams.get('shop_id')
  const users = await query(
    'SELECT id, shop_id, name, role, created_at FROM shop_users WHERE shop_id = ? ORDER BY created_at',
    [shopId]
  )
  return NextResponse.json(users)
}

export async function POST(req: Request) {
  const { shop_id, name, pin, role } = await req.json()
  const id = uuid()
  await query(
    'INSERT INTO shop_users (id, shop_id, name, pin, role) VALUES (?, ?, ?, ?, ?)',
    [id, shop_id, name, pin, role]
  )
  const user = await queryOne(
    'SELECT id, shop_id, name, role, created_at FROM shop_users WHERE id = ?',
    [id]
  )
  return NextResponse.json(user)
}

export async function DELETE(req: Request) {
  const { searchParams } = new URL(req.url)
  const id = searchParams.get('id')
  await query('DELETE FROM shop_users WHERE id = ?', [id])
  return NextResponse.json({ ok: true })
}
